import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import ProjectFormContainer from './ProjectFormContainer';

const ChanceAddContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState({ name: '기회 신규 추가' });
  const handleGoBack = () => {
    navigate('/chancemng');
  };
  return (
    <>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="포케스팅 관리/포케스팅 등록/기회 추가"
        menuLink="/chancemng"
        icon="chance"
        titleData={titleData}
      />
      <ProjectFormContainer type="add" />
    </>
  )
};

export default ChanceAddContainer;
